import { createContext, useContext } from 'react';
import type { AppConfig, Me } from '../api/types';
import { hasPermission, type Permission } from './roles';

export interface AuthState {
  config: AppConfig;
  me: Me;
  /** Present in `jwt` mode. */
  signOut?: () => void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const state = useContext(AuthContext);
  if (!state) throw new Error('useAuth must be used inside AuthContext.');
  return state;
}

export function usePermission(permission: Permission): boolean {
  return hasPermission(useAuth().me, permission);
}
